import logo from "assets/images/logo.png";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { adminRoutes } from "router";
import { settings } from "settings";
import { permissionStore } from "store/permissionStore";
import { userStore } from "store/userStore";
import { getTitle } from "utils";
import LoginForm from "views/Login/components/Form";
import "./styles/LoginPage.scss";
import { Carousel, message } from "antd";
import { toJS } from "mobx";
import ImageSlider from "views/Login/components/SlideImage";

import bg1 from "../../assets/images/bg1.png";
import bg2 from "../../assets/images/bg2.png";
import bg3 from "../../assets/images/bg3.png";

const bgCard = [bg1, bg2, bg3];

type LoginPageProps = {
  title?: string;
};

const LoginPage = observer(({ title = "" }: LoginPageProps) => {
  const [loading, setLoading] = useState(false);
  const navigation = useNavigate();

  useEffect(() => {
    document.title = getTitle(title);
  }, [title]);

  const handleSubmit = async (form: any) => {
    setLoading(true);
    const username = form.username;
    const password = form.password;
    try {
      await userStore.login(username, password);
      await userStore.getProfile();
      permissionStore.accessRoutes = [...adminRoutes];
      // console.log("userStore.info", toJS(userStore.info.role));
      if (settings.checkPermission && userStore.info.role) {
        await permissionStore.fetchPermissions(userStore.info.role.id);
        if (!permissionStore.permissions.length) {
          message.error("Không có quyền truy cập");
          throw new Error("");
        }
        permissionStore.setAccessRoutes();
        navigation(permissionStore.permissions[0].path);
      } else {
        navigation("/");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__image">
        <ImageSlider images={bgCard} />
      </div>
      <div className="login-page__content border-l border-gray-200">
        <div className="login-page__card">
          <div className="login-page__card-body">
            <div className="login-page__brand">
              <img src={logo} width={80} alt="Logo" className="login-page__logo" />
            </div>

            <h1 className="text-2xl font-bold text-primary text-center mb-3">BMD Chat AI</h1>

            <LoginForm loading={loading} onSubmit={handleSubmit} />

            <p className="login-page__footer-text">
              &copy; {new Date().getFullYear()} - {settings.version}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
});

export default LoginPage;
